import { render, staticRenderFns } from "./groupCustomer.vue?vue&type=template&id=78857445&scoped=true"
import script from "./groupCustomer.vue?vue&type=script&lang=js"
export * from "./groupCustomer.vue?vue&type=script&lang=js"
import style0 from "./groupCustomer.vue?vue&type=style&index=0&id=78857445&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78857445",
  null
  
)

export default component.exports